import { REFRESH_TOKEN } from '@/constants/common';
import { CookieKeys, CookieService } from '@/utils/cookie-service';
import { APP_METHODS } from '@/utils/enums';
import { invokeAppMethod } from '@/utils/utils';

/** Persist K8/app iframe query auth so `/v2` can load the logged-in user. */
export function hydrateSessionFromAppQuery(): void {
  if (typeof window === 'undefined') return;

  const searchParams = new URLSearchParams(window.location.search);
  const fromApp = searchParams.get('from_app');
  if (fromApp === 'true') {
    localStorage.setItem('from_app', 'true');
  }

  const platform = searchParams.get('platform');
  if (platform) {
    localStorage.setItem('platform', platform);
  }

  const token = searchParams.get('token') || searchParams.get('TOKEN');
  if (token) {
    localStorage.setItem('TOKEN', token);
    localStorage.setItem('token', token);
    const existing = CookieService.getValue(CookieKeys.TOKEN_CONTEXT);
    CookieService.setValue(CookieKeys.TOKEN_CONTEXT, {
      ...(typeof existing === 'object' && existing ? existing : {}),
      token,
    });
  }

  const refreshToken = searchParams.get('refresh_token') || searchParams.get('REFRESH_TOKEN');
  if (refreshToken) {
    localStorage.setItem(REFRESH_TOKEN, refreshToken);
  }
}

export function leaveAppWebView(): void {
  invokeAppMethod(APP_METHODS.EXIT_SCREEN);
  invokeAppMethod(APP_METHODS.CLOSE_WEB_VIEW);
  invokeAppMethod(APP_METHODS.HANDLE_CONTINUE_LEARNING);
}
